/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_ORDER_STATE_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepOrder';
export const ixcSweepsClearingV1SweepOrderStateEntity = new schema.Entity<IxcSweepsClearingV1SweepOrderState>(IXC_SWEEPS_CLEARING_V1_SWEEP_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'sweepOrderId' });

